import '../styles/pieces/nutritional_label.scss';
// import '../styles/pieces/nutritional_label'
// STARTED AND STOPPED
// FINISH

const NutritionalLabel = ({ nf }) => {
    console.log('NutritionalLabel', nf);
    const isValueValid = (value) => value !== null && value !== "";

    return (
        <section className="performance-facts">
            <header className="performance-facts__header">
                <h1 className="performance-facts__title">Nutrition Facts</h1>
                {isValueValid(nf.servings_size) && <p>Serving Size{" "}{nf.servings_size}</p>}
                {isValueValid(nf.servings) && <p>{nf.servings}{" "}Serving Per Container</p>}
            </header>
            <table className="performance-facts__table">
                <thead>
                    <tr>
                        <th colSpan="3" className="small-info">
                            Amount Per Serving
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th colSpan="2">
                            <b>Calories</b>{" "}
                            <span className='number'>{nf.calories}</span>
                        </th>
                        {isValueValid(nf.calories_fat) && (
                            <td>
                                Calories from Fat{" "}
                                <span className='number'>{nf.calories_fat}</span>
                            </td>
                        )}
                    </tr>
                    <tr className="thick-row">
                        <td colSpan="3" className="small-info">
                            <b>% Daily Value*</b>
                        </td>
                    </tr>
                    {isValueValid(nf.fat) && (
                        <tr>
                            <th colSpan="2">
                                <b>Total Fat</b>{" "}
                                <span className='number'>{nf.fat}</span>g
                            </th>
                            <td>
                                <span dangerouslySetInnerHTML={{__html: getDailyVal(nf.fat_dv)}}></span>
                            </td>
                        </tr>
                    )}
                    {isValueValid(nf.saturated_fat) && (
                        <tr>
                            <td className="blank-cell"></td>
                            <th>
                                Saturated Fat{" "}
                                <span className='number'>{nf.saturated_fat}</span>g
                            </th>
                            <td>
                                <span dangerouslySetInnerHTML={{__html: getDailyVal(nf.saturated_fat_dv)}}></span>
                            </td>
                        </tr>
                    )}
                    {isValueValid(nf.trans_fat) && (
                        <tr>
                            <td className="blank-cell"></td>
                            <th>
                                Trans Fat{" "}
                                <span className='number'>{nf.trans_fat}</span>g
                            </th>
                            <td>
                                <span dangerouslySetInnerHTML={{__html: getDailyVal(nf.trans_fat_dv)}}></span>
                            </td>
                        </tr>
                    )}
                    {isValueValid(nf.polyunsaturated_fat) && (
                        <tr>
                            <td className="blank-cell"></td>
                            <th>
                                Polyunsaturated Fat{" "}
                                <span className='number'>{nf.polyunsaturated_fat}</span>g
                            </th>
                        </tr>
                    )}
                    {isValueValid(nf.monounsaturated_fat) && (
                        <tr>
                            <td className="blank-cell"></td>
                            <th>
                                Monounsaturated Fat{" "}
                                <span className='number'>{nf.monounsaturated_fat}</span>g
                            </th>
                        </tr>
                    )}
                    {isValueValid(nf.cholesterol) && (
                        <tr>
                            <th colSpan="2">
                                <b>Cholesterol</b>{" "}
                                <span className='number'>{nf.cholesterol}</span>mg
                            </th>
                            <td>
                                <span dangerouslySetInnerHTML={{__html: getDailyVal(nf.cholesterol_dv)}}></span>
                            </td>
                        </tr>
                    )}
                    {isValueValid(nf.sodium) && (
                        <tr>
                            <th colSpan="2">
                                <b>Sodium</b>{" "}
                                <span className='number'>{nf.sodium}</span>mg
                            </th>
                            <td>
                                <span dangerouslySetInnerHTML={{__html: getDailyVal(nf.sodium_dv)}}></span>
                            </td>
                        </tr>
                    )}
                    {isValueValid(nf.potassium) && (
                        <tr>
                            <th colSpan="2">
                                <b>Potassium</b>{" "}
                                <span className='number'>{nf.potassium}</span>mg
                            </th>
                            <td>
                                <span dangerouslySetInnerHTML={{__html: getDailyVal(nf.potassium_dv)}}></span>
                            </td>
                        </tr>
                    )}
                    {isValueValid(nf.carbohydrate) && (
                        <tr>
                            <th colSpan="2">
                                <b>Total Carbohydrate</b>{" "}
                                <span className='number'>{nf.carbohydrate}</span>g
                            </th>
                            <td>
                                <span dangerouslySetInnerHTML={{__html: getDailyVal(nf.carbohydrate_dv)}}></span>
                            </td>
                        </tr>
                    )}
                    {isValueValid(nf.dietary_fiber) && (
                        <tr>
                            <td className="blank-cell"></td>
                            <th>
                                Dietary Fiber{" "}
                                <span className='number'>{nf.dietary_fiber}</span>g
                            </th>
                            <td>
                                <span dangerouslySetInnerHTML={{__html: getDailyVal(nf.dietary_fiber_dv)}}></span>
                            </td>
                        </tr>
                    )}
                    {isValueValid(nf.sugars) && (
                        <tr>
                            <td className="blank-cell"></td>
                            <th>
                                Sugars{" "}
                                <span className='number'>{nf.sugars}</span>g
                            </th>
                            <td>
                                <span dangerouslySetInnerHTML={{__html: getDailyVal(nf.sugars_dv)}}></span>
                            </td>
                        </tr>
                    )}
                    {isValueValid(nf.added_sugars) && (
                        <tr>
                            <td className="blank-cell"></td>
                            <th>
                                Added Sugars{" "}
                                <span className='number'>{nf.added_sugars}</span>g
                            </th>
                            <td>
                                <span dangerouslySetInnerHTML={{__html: getDailyVal(nf.added_sugars_dv)}}></span>
                            </td>
                        </tr>
                    )}
                    {isValueValid(nf.protein) && (
                        <tr className="thick-end">
                            <th colSpan="2">
                                <b>Protein</b>{" "}
                                <span className='number'>{nf.protein}</span>g
                            </th>
                            <td>
                                <span dangerouslySetInnerHTML={{__html: getDailyVal(nf.protein_dv)}}></span>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <table className="performance-facts__table--grid">
                <tbody>
                    {isValueValid(nf.vitamin_a) && (
                        <tr>
                            <td>
                                Vitamin A{" "}<span className='number'>{nf.vitamin_a_dv}</span>%
                            </td>
                            <td>
                                Vitamin C{" "}<span className='number'>{nf.vitamin_c_dv}</span>%
                            </td>
                        </tr>
                    )}
                    {isValueValid(nf.vitamin_d) && (
                        <tr>
                            <td>
                                Vitamin D{" "}<span className='number'>{nf.vitamin_d_dv}</span>%
                            </td>
                            <td>
                                Calcium{" "}<span className='number'>{nf.calcium_dv}</span>%
                            </td>
                        </tr>
                    )}
                    {isValueValid(nf.iron) && (
                        <tr>
                            <td>
                                Iron{" "}<span className='number'>{nf.iron_dv}</span>%
                            </td>
                            <td>
                                Potassium{" "}<span className='number'>{nf.potassium_dv}</span>%
                            </td>
                        </tr>
                    )}
                    {isValueValid(nf.riboflavin) && (
                        <tr>
                            <td>
                                Riboflavin{" "}<span className='number'>{nf.riboflavin_dv}</span>%
                            </td>
                            <td>
                                Niacin{" "}<span className='number'>{nf.niacin_dv}</span>%
                            </td>
                        </tr>
                    )}
                    {isValueValid(nf.vitamin_b6) && (
                        <tr>
                            <td>
                                Vitamin B6{" "}<span className='number'>{nf.vitamin_b6_dv}</span>%
                            </td>
                            <td>
                                Vitamin B12{" "}<span className='number'>{nf.vitamin_b12_dv}</span>%
                            </td>
                        </tr>
                    )}
                    {isValueValid(nf.phosphorus) && (
                        <tr>
                            <td>
                                Phosphorus{" "}<span className='number'>{nf.phosphorus_dv}</span>%
                            </td>
                            <td>
                                Selenium{" "}<span className='number'>{nf.selenium_dv}</span>%
                            </td>
                        </tr>
                    )}
                    {isValueValid(nf.zinc) && (
                        <tr>
                            <td>
                                Zinc{" "}<span className='number'>{nf.zinc_dv}</span>%
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <p className="small-info">* Percent Daily Values are based on a 2,000 calorie diet. Your daily values may be higher or lower depending on your calorie needs:</p>

            <table className="performance-facts__table--small small-info">
                <thead>
                    <tr>
                        <td colSpan="2"></td>
                        <th>Calories:</th>
                        <th>2,000</th>
                        <th>2,500</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th colSpan="2">Total Fat</th>
                        <td>Less than</td>
                        <td>65g</td>
                        <td>80g</td>
                    </tr>
                    <tr>
                        <td className="blank-cell"></td>
                        <th>Saturated Fat</th>
                        <td>Less than</td>
                        <td>20g</td>
                        <td>25g</td>
                    </tr>
                    <tr>
                        <th colSpan="2">Cholesterol</th>
                        <td>Less than</td>
                        <td>300mg</td>
                        <td>300mg</td>
                    </tr>
                    <tr>
                        <th colSpan="2">Sodium</th>
                        <td>Less than</td>
                        <td>2,400mg</td>
                        <td>2,400mg</td>
                    </tr>
                    <tr>
                        <th colSpan="3">Total Carbohydrate</th>
                        <td>300g</td>
                        <td>375g</td>
                    </tr>
                    <tr>
                        <td className="blank-cell"></td>
                        <th colSpan="2">Dietary Fiber</th>
                        <td>25g</td>
                        <td>30g</td>
                    </tr>
                </tbody>
            </table>

            <p className="small-info">
                Calories per gram:
            </p>
            <p className="small-info text-center">
                Fat 9 &bull; Carbohydrate 4 &bull; Protein 4
            </p>
        </section>
    );
};



function getDailyVal(amount, key=false) {
    const fda = {
      fat: 78,
      carbohydrate: 275,
      protein: 50,
      saturated_fat: 20,
      sodium: 2300,
      cholesterol: 300,
      vitamin_d: 20,
      vitamin_a: 900,
      vitamin_c: 90,
      calcium: 1300,
      dietary_fiber: 28,
      iron: 18,
      potassium: 4700,
      added_sugars: 50,
      riboflavin: 1.3,
      niacin: 16,
      vitamin_b6: 1.7,
      vitamin_b12: 2.4,
      phosphorus: 4700,
      zinc: 11,
      selenium: 55,
    };

    if(amount !== '' || amount == null){
        return `<span class="number">${amount}</span>%`;
    } else {
        return '';
    }
    
    //Not using this anymore
    // if (!fda.hasOwnProperty(key)) {
    //   console.error("getDailyVal was handed an invalid type: " + key);
    //   return;
    // }
  
    // const dailyValue = fda[key];
    // return Math.round((amount / dailyValue) * 100);
  }
  

export default NutritionalLabel;